export const PRICE_INCLUDES_VAT_CONFIG_KEY = 'webshop-string-price-includes-vat';
export const HAS_VOUCHER_CONFIG_KEY = 'webshop-string-has-voucher';
export const OPERATOR_FACILITY_REQUIRED_CONFIG_KEY = 'webshop-string-operator-facility-required';
export const REGISTRATION_APPROVE_REQUIRED_CONFIG_KEY =
  'webshop-string-registration-approve-required';
export const ACTIVE_TRANSPORTER_CONFIG_KEY = 'webshop-json-active-transporter';
export const MIN_ORDER_CONFIG_KEY = 'webshop-int-order-min-amount';
export const CASH_LIMIT_CONFIG_KEY = 'webshop-int-cash-limit';
export const COMPANIES_MIN_CONFIG_KEY = 'webshop-int-companies-min';
export const COMPANIES_MAX_CONFIG_KEY = 'webshop-int-companies-max';
export const COUNTRY_CODES_CONFIG_KEY = 'webshop-list-country-codes';
export const PAYMENT_METHODS_CONFIG_KEY = 'webshop-list-payment-methods';
